<template>
    <router-link :to="this.to" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li :class="['nav-item', (isActive &&isExactActive) && 'active']">
            <a class="nav-link" :href="href" @click="navigate">{{name}}</a>
        </li>
    </router-link>
</template>

<script>
    export default {
        props: ["to","name"]
    }
</script>